<ngx-json-ld [json]="schema"></ngx-json-ld>
<app-header #header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>
<div class="container">
  <div class="section s1">
    <div class="section-content">
      <div class="w50"><img class="s1-img" [src]="'./assets/images/amazon_prime_video_img_' + getLangForHeroImage() + '.jpg'" alt="prime video deals"></div>
      <div class="w50">
        <h1>{{getString('primeVideoDeals')}}</h1>
        <b>{{getString('primeVideoDealsS1Subtitle')}}</b>
        <p>{{getString('primeVideoDealsS1Text')}}</p>
        <div class="txt-algn-cntr"><a [routerLink]="'/' + getCountry() + '/amazon/' + getString('moviesUrl') + '/' + getString('onSaleUrl')"><button type="button" class="big-btn blue-button">{{getString('seeTheOffers')}}</button></a></div>
      </div>
    </div>
  </div>
  <div class="section s2">
    <div class="section-content">
      <div class="w60">
        <h2>{{getString('primeVideoDealsS2Title')}}</h2>
        <p>{{getString('primeVideoDealsS2Text')}}</p>
      </div>
      <div class="w40 txt-algn-cntr">
        <div class="gray-title">{{getString('todaysTopseller')}}</div>
        <app-single-carousel *ngIf="items" [items]="items" [title]="'amazon'" (onWishlistClick)="wishListClicked($event)"></app-single-carousel>
        <div class="txt-algn-cntr"><a [routerLink]="'/' + getCountry() + '/amazon/' + getString('moviesUrl') + '/' + getString('onSaleUrl')"><button type="button" class="big-btn blue-button">{{getString('moreTopDeals')}}</button></a></div>
      </div>
    </div>
  </div>
  <div class="section s3">
    <div class="section-content">
        <div class="w40 txt-algn-cntr">
          <div class="gray-title">{{getString('userReviews')}}</div>
          <app-single-review></app-single-review>
        </div>
        <div class="w60">
      <h2>{{getString('primeVideoDealsS3Title')}}</h2>
      <p>{{getString('primeVideoDealsS3Text')}}</p>
        </div>
    </div>
  </div>
  <div class="section">
    <div class="section-content">
        <div class="w60">
          <h2>{{getString('primeVideoDealsS4Title')}}</h2>
          <p>{{getString('primeVideoDealsS4Text')}}</p>
          <div class="txt-algn-cntr">
            <a [routerLink]="'/' + getCountry() + '/' + getString('wishlistUrl')">
              <button type="button" class="big-btn blue-button">{{getString('addMovies')}}</button>
            </a>
          </div>
        </div>
        <div class="w40 txt-algn-cntr">
          <span class="gray-title">{{getString('cheapChartsSmartWishList')}}</span>
          <img class="s4-img" src="./assets/images/wishlist_bell_piggy.png" alt="itunes wishlist">
          <div class="s4-steps">
            <div>{{getString('primeVideoDealsS4Step1')}}</div>
            <div>{{getString('primeVideoDealsS4Step2')}}</div>
            <div class="blue-text">{{getString('primeVideoDealsS4Step3')}}</div>
          </div>
        </div>
    </div>
  </div>
  <div class="section">
    <app-faq class="faq-section-content" [faqCategory]="'prime-video-deals'"></app-faq>
    <div class="page-links">
      <a [routerLink]="'/' + getCountry() + '/' + getString('itunesMovieDealsUrl')">{{getString('itunesMovieDeals')}}</a> |
      <a [routerLink]="'/' + getCountry() + '/' + getString('primeVideoDealsUrl')" class="blue-text">{{getString('amazonMovieDeals')}}</a>
      <ng-container *ngIf="getCountry() == 'us'"> | <a [routerLink]="'/us/' + getString('vuduMovieDealsUrl')">{{getString('vuduMovieDeals')}}</a></ng-container>
    </div>
  </div>
</div>
<div>
  <app-home-footer></app-home-footer>
</div>
